import api from './api';

export default {
    index(search=false,status=false , sort=false,page=1 , category=''){
        return api.get(`${process.env.VUE_APP_URL}/trainings` , {params: {search:search , status:status, sort:sort , page:page , category:category}});
    },
    create(params){
        return api.post(`${process.env.VUE_APP_URL}/trainings` , params);
    },
    show(id){
        return api.get(`${process.env.VUE_APP_URL}/trainings/${id}`);
    },
    update(id , params){
        return api.put(`${process.env.VUE_APP_URL}/trainings/${id}` , params);
    },
    delete(id){
        return api.delete(`${process.env.VUE_APP_URL}/trainings/${id}`);
    },
    start(id){
        return api.get(`${process.env.VUE_APP_URL}/training/start/${id}`);
    },
    assignUsers(type , id , params){
        return api.post(`${process.env.VUE_APP_URL}/trainings/assign/${type}/${id}` , params);
    },
    getNotUsersAssigned(type , id){
        return api.get(`${process.env.VUE_APP_URL}/trainings/users/notAssigned/${type}/${id}`);
    },
    getUsersAssigned(id){
        return api.get(`${process.env.VUE_APP_URL}/trainings/users/assigned/${id}`);
    },
    deleteUserAssigned(id){
        return api.delete(`${process.env.VUE_APP_URL}/trainings/delete/user/assigned/${id}`);
    },
    playCompetition(type , id){
        return api.put(`${process.env.VUE_APP_URL}/trainings/play/team/${id}` , {type:type});
    },
    getTrainingPublic(search=false,status=false , sort=false,page=1 , category='public'){
        return api.get(`${process.env.VUE_APP_URL}/user/get-public-trainings` , {params: {search:search , status:status, sort:sort , page:page , category:category}});
    },
    getTrainingPublicUser(search=false,status=false , sort=false,page=1 , category='public'){
        return api.get(`${process.env.VUE_APP_URL}/user/get-public-trainings-user` , {params: {search:search , status:status, sort:sort , page:page , category:category}});
    },
    getTrainingPrivate(search=false,status=false , sort=false,page=1 , category='private'){
        return api.get(`${process.env.VUE_APP_URL}/user/assigned-training` , {params: {search:search , status:status, sort:sort , page:page , category:category}});
    },
}